const STATE_UP = 'UP';
const STATE_DOWN = 'DOWN';

export default class Slideable {

	constructor(element, duration = 300) {
		this.element = element;
		this.duration = duration;
		this.originalStyle = {};
		this.originalDisplay = null;
		this.state = STATE_UP;
	}

	_prepare() {
		Object.assign(this.originalStyle, this.element.style);
		this.originalDisplay = window.getComputedStyle(this.element).display;

		Object.assign(
			this.element.style,
			{
				overflow: 'hidden',
				transition: 'height ' + this.duration + 'ms ease, width ' + this.duration + 'ms ease'
			}
		);

		this._calculateSize();
	}

	_finalize() {
		this.element.style = this.originalStyle;
		
		if(this.state == STATE_UP && this.isHidden())
			this.element.style.display = 'block';

		if(this.state == STATE_DOWN && !this.isHidden())
			this.element.style.display = 'none';
	}

	_calculateSize() {
		let display = this.element.display;
		if(this.isHidden())
			this.element.style.display = 'block';
		this.height = this.element.getBoundingClientRect().height;
		this.width = this.element.getBoundingClientRect().width;
		this.element.style.display = display;
	}

	up() {
		this.state = STATE_UP;
		this._prepare();

		this.element.style.display = this.originalDisplay === 'none' ? 'block' : this.originalDisplay;
		this.element.style.height = '0px';

		setTimeout(() => {
			this.element.style.height = this.height + 'px';
		}, 10);

		setTimeout(() => {
			this._finalize();
		}, this.duration + 10);
	}

	down() {
		this.state = STATE_DOWN;
		this._prepare();
		this.element.style.height = this.height + 'px';

		setTimeout(() => {
			this.element.style.height = 0;
		}, 10);

		setTimeout(() => {
			this.element.style.display = 'none';
			this._finalize();
		}, this.duration + 10);
	}

	toggle() {
		if (this.isHidden()) {
			return this.up(this.element, this.duration);
		} else {
			return this.down(this.element, this.duration);
		}
	}

	isHidden() {
		return window.getComputedStyle(this.element).display === 'none';
	}
}